import { defineMessages } from 'react-intl';

export default defineMessages({
    reasonNotListedAsDriver: {
        id: 'ml.policychange.MLAddVehicleOperatorComponent.Reason Not Listed as Driver',
        defaultMessage: 'Reason Not Listed as Driver'
    },
    maritalStatusTipTitle: {
        id: 'ml.policychange.MLAddVehicleOperatorComponent.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    maritalStatusTip: {
        id: 'ml.policychange.MLAddVehicleOperatorComponent.Marital Status Tooltip Content',
        defaultMessage: 'A civil union is defined as a state level legally recognized same-sex marriage. A domestic partner is a relationship between two individuals (same-or opposite-sex) who live together but are not married.'
    },
    dontHaveThis: {
        id: "ml.policychange.MLAddVehicleOperatorComponent.What if I don't have this right now?",
        defaultMessage: "What if I don't have this right now?"
    },
    informationRequiredLater: {
        id: 'ml.policychange.MLAddVehicleOperatorComponent.Entry in this field is optional on this page. Information will be required later in quote.',
        defaultMessage: 'Entry in this field is optional on this page. Information will be required later in quote.'
    },
    stateTipTitle: {
        id: "ml.policychange.MLAddVehicleOperatorComponent.What if I don't have a US license?",
        defaultMessage: "What if I don't have a US license? {break} What if I don't have this right now?"
    },
    stateTip: {
        id: 'ml.policychange.MLAddVehicleOperatorComponent.State Tooltip Content',
        defaultMessage: 'Select DC, Canada, US Territories or Foreign as your state licensed. {break} Entry in this field is optional on this page. Information will be required later in quote.'
    },
    checkUniqueSelfMessage: {
        id: 'ml.policychange.MLAddVehicleOperatorComponent.Self has already been selected as a relationship to insured on another driver.',
        defaultMessage: 'Self has already been selected as a relationship to insured on another driver.'
    },
    checkUniqueSpouseMessage: {
        id: 'ml.policychange.MLAddVehicleOperatorComponent.Spouse has already been selected as a relationship to insured on another driver.',
        defaultMessage: 'Spouse has already been selected as a relationship to insured on another driver.'
    },
});
